import { workerService } from '@/services';
import WorkerVM from '@/view-model/worker-management/WorkerVM';
export default {
    resetWorkerDetail({ commit }) {
        commit('RESET_WORKER_DETAIL');
    },
    async getWorkerDetail({ commit }, code) {
        const response = await workerService.getWorker({
            workerCode: code,
        });
        const res = new WorkerVM(response.data);
        commit('GET_WORKER_DETAIL', res);
    },
};
